// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listLineContainerStyles } from "@awc/App/Components/MyListsDetails/ListLineContainer";
import { avoidBreakInsidePrintElement, color, xScreen } from "@awc/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { css } from "styled-components";

listLineContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 32px 140px minmax(0, 700px) minmax(40px, 1fr) minmax(0, 350px);
        width: 100%;
        background: ${color("common.white")};
        border: 1px solid ${color("common.border")};
        border-top: 6px solid ${color("common.ui14")};
        padding: 12px;
        margin-bottom: 10px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 25px 112px minmax(0, 700px) minmax(40px, 1fr) minmax(0, 317px);
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: 0 112px minmax(0, 700px) minmax(40px, 1fr) minmax(0, 317px);
        }
        ${avoidBreakInsidePrintElement}
        @media print {
            margin: 1px 0; // show borders on print
        }
    `,
};

listLineContainerStyles.checbox = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 6;
        line-height: 16px;
        ${xScreen("lte", "sm")} {
            grid-column: 1 /7;
            grid-row: 1 / 2;
            padding-bottom: 12px;
        }
    `,
};

listLineContainerStyles.image = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 6;
        ${xScreen("lte", "md")} {
            grid-row: 1 / 5;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1 /3;
            grid-row: 2 / 5;
        }
    `,
};

listLineContainerStyles.description = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 3;
        display: inline-flex;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 6;
        }
        ${xScreen("lte", "sm")} {
            grid-row: 2 / 4;
        }
    `,
};

listLineContainerStyles.price = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 1 / 2;
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 6;
            grid-row: 4 / 5;
        }
        @media print {
            grid-column: 5 / 6;
            grid-row: 1 / 2;
        }
    `,
};

listLineContainerStyles.actions = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 2 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 6;
            grid-row: 5 / 6;
            > ${StyledWrapper} {
                max-width: 350px;
            }
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 6;
            > ${StyledWrapper} {
                max-width: 100%;
            }
        }
        @media print {
            grid-column: 5 / 6;
            grid-row: 2 / 5;
        }
    `,
};

listLineContainerStyles.deleteItem = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 3 / 4;
        ${xScreen("lte", "md")} {
            grid-column: 4 / 6;
            grid-row: 6 / 7;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 3 / 6;
            z-index: 1;
        }
        @media print {
            grid-column: 1 / 6;
            grid-row: 7 / 8;
        }
    `,
};

listLineContainerStyles.notes = {
    css: css`
        grid-column: 1 / 6;
        grid-row: 6 / 7;
        margin-top: 12px;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 6;
            grid-row: 6 / 7;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1/ 7;
        }
        @media print {
            grid-column: 1 / 6;
            grid-row: 6 / 7;
        }
    `,
};
